import React, { useState, useEffect } from 'react';

const BusinessTypeInput = ({ value = '', onChange, placeholder = "可多选/逗号分隔" }) => {
  const [inputValue, setInputValue] = useState('');
  const [selectedTypes, setSelectedTypes] = useState([]);
  
  // 预设的业务类型
  const presetTypes = [
    { id: '印章刻制', label: '印章刻制' },
    { id: '印章新刻', label: '印章新刻' },
    { id: '印章换刻', label: '印章换刻' },
    { id: '印章补刻', label: '印章补刻' },
    { id: '印章更名换刻', label: '印章更名换刻' },
    { id: '印章遗失补刻', label: '印章遗失补刻' },
    { id: '印章作废补刻', label: '印章作废补刻' }
  ];

  // 初始化选中状态
  useEffect(() => {
    if (value) {
      const types = value.split(',').map(t => t.trim()).filter(t => t);
      setSelectedTypes(types);
    }
  }, [value]);

  // 处理预设业务类型的勾选
  const handlePresetChange = (typeId, checked) => {
    let newTypes;
    if (checked) {
      newTypes = [...selectedTypes, typeId];
    } else {
      newTypes = selectedTypes.filter(t => t !== typeId);
    }
    setSelectedTypes(newTypes);
    onChange(newTypes.join(', '));
  };

  // 处理自定义输入
  const handleInputKeyPress = (e) => {
    if (e.key === 'Enter' && inputValue.trim()) {
      e.preventDefault();
      const newType = inputValue.trim();
      if (!selectedTypes.includes(newType)) {
        const newTypes = [...selectedTypes, newType];
        setSelectedTypes(newTypes);
        onChange(newTypes.join(', '));
      }
      setInputValue('');
    }
  };

  // 删除业务类型
  const removeType = (typeToRemove) => {
    const newTypes = selectedTypes.filter(t => t !== typeToRemove);
    setSelectedTypes(newTypes);
    onChange(newTypes.join(', '));
  };

  return (
    <div style={{ width: '100%' }}>
      {/* 预设业务类型选项 */}
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '6px',
        marginBottom: '16px',
        padding: '12px',
        background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
        borderRadius: '8px',
        border: '1px solid #dee2e6',
        boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.05)'
      }}>
        {presetTypes.map(type => (
          <label key={type.id} style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            padding: '6px 12px',
            background: selectedTypes.includes(type.id) 
              ? 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)' 
              : 'linear-gradient(135deg, #fff 0%, #f8f9fa 100%)',
            border: `1px solid ${selectedTypes.includes(type.id) ? '#2196f3' : '#ced4da'}`,
            borderRadius: '20px',
            cursor: 'pointer',
            fontSize: '13px',
            fontWeight: selectedTypes.includes(type.id) ? '500' : '400',
            color: selectedTypes.includes(type.id) ? '#1976d2' : '#495057',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            boxShadow: selectedTypes.includes(type.id) 
              ? '0 2px 8px rgba(33, 150, 243, 0.3)' 
              : '0 1px 3px rgba(0,0,0,0.1)',
            userSelect: 'none'
          }}
          onMouseOver={(e) => {
            if (!selectedTypes.includes(type.id)) {
              e.target.style.background = 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)';
              e.target.style.borderColor = '#2196f3';
              e.target.style.transform = 'translateY(-1px)';
              e.target.style.boxShadow = '0 4px 12px rgba(33, 150, 243, 0.2)';
            }
          }}
          onMouseOut={(e) => {
            if (!selectedTypes.includes(type.id)) {
              e.target.style.background = 'linear-gradient(135deg, #fff 0%, #f8f9fa 100%)';
              e.target.style.borderColor = '#ced4da';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
            }
          }}
          >
            <input
              type="checkbox"
              checked={selectedTypes.includes(type.id)}
              onChange={(e) => handlePresetChange(type.id, e.target.checked)}
              style={{ 
                margin: 0,
                width: '14px',
                height: '14px',
                accentColor: '#2196f3'
              }}
            />
            {type.label}
          </label>
        ))}
      </div>

      {/* 自定义输入区域 */}
      <div style={{
        border: '1px solid #ced4da',
        borderRadius: '8px',
        padding: '12px',
        minHeight: '48px',
        background: 'linear-gradient(135deg, #fff 0%, #f8f9fa 100%)',
        display: 'flex',
        flexWrap: 'wrap',
        gap: '8px',
        alignItems: 'center',
        boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.05)',
        transition: 'all 0.3s ease'
      }}
      onFocus={(e) => {
        e.currentTarget.style.borderColor = '#2196f3';
        e.currentTarget.style.boxShadow = 'inset 0 1px 3px rgba(0,0,0,0.05), 0 0 0 3px rgba(33, 150, 243, 0.1)';
      }}
      onBlur={(e) => {
        e.currentTarget.style.borderColor = '#ced4da';
        e.currentTarget.style.boxShadow = 'inset 0 1px 3px rgba(0,0,0,0.05)';
      }}
      >
        {/* 已选择的业务类型标签 */}
        {selectedTypes.map(type => (
          <span key={type} style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            padding: '4px 12px',
            background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
            border: '1px solid #2196f3',
            borderRadius: '16px',
            fontSize: '12px',
            fontWeight: '500',
            color: '#1976d2',
            boxShadow: '0 2px 4px rgba(33, 150, 243, 0.2)',
            transition: 'all 0.2s ease',
            animation: 'fadeIn 0.3s ease'
          }}>
            <span style={{ fontSize: '14px', marginRight: '2px' }}>📋</span>
            {type}
            <button
              type="button"
              onClick={() => removeType(type)}
              style={{
                background: 'rgba(25, 118, 210, 0.1)',
                border: 'none',
                color: '#1976d2',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: 'bold',
                padding: '2px 4px',
                marginLeft: '4px',
                borderRadius: '50%',
                width: '18px',
                height: '18px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.2s ease',
                lineHeight: '1'
              }}
              onMouseOver={(e) => {
                e.target.style.background = 'rgba(25, 118, 210, 0.2)';
                e.target.style.transform = 'scale(1.1)';
              }}
              onMouseOut={(e) => {
                e.target.style.background = 'rgba(25, 118, 210, 0.1)';
                e.target.style.transform = 'scale(1)';
              }}
            >
              ×
            </button>
          </span>
        ))}
        
        {/* 输入框 */}
        <input
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyPress={handleInputKeyPress}
          placeholder={selectedTypes.length === 0 ? placeholder : "输入其他业务类型，按回车添加"}
          style={{
            border: 'none',
            outline: 'none',
            flex: '1',
            minWidth: '140px',
            fontSize: '14px',
            background: 'transparent',
            color: '#495057',
            padding: '4px 0'
          }}
        />
      </div>
      
      {/* 提示文字 */}
      <div style={{
        fontSize: '12px',
        color: '#6c757d',
        marginTop: '8px',
        padding: '8px 12px',
        background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
        borderRadius: '6px',
        border: '1px solid #dee2e6',
        display: 'flex',
        alignItems: 'center',
        gap: '6px'
      }}>
        <span style={{ fontSize: '14px' }}>💡</span>
        可勾选预设业务类型，或输入自定义业务类型后按回车键添加
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default BusinessTypeInput; 